import {
    StyleSheet
} from "react-native";
import type {
    ViewStyle
} from "react-native";
import {
    webStyle
} from "ncore-ui-kit";

const stylesheet = StyleSheet.create({
    container: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%"
    } as ViewStyle,
    leftContainer: {
        flexDirection: "row",
        alignItems: "center",
        flex: 1
    } as ViewStyle,
    iconContainer: {
        marginRight: 12
    } as ViewStyle,
    textContainer: {
        flex: 1,
        marginRight: 8
    } as ViewStyle,
    button: {
        justifyContent: "center",
        alignItems: "center",
        ...webStyle({
            cursor: "pointer"
        })
    } as ViewStyle
});

export default stylesheet;
